




import IMediumDto from "./MediumDto.if";
import mappings from "./MediumDto.map";
import ISiteDto from "./SiteDto.if";
import SiteDto from "./SiteDto";

import { IModelSource } from "./private/db.if";
import Transformers from './private/transformer';
import DBUtil from './private/db.util';
import SiteObjectTranslationDto from "./SiteObjectTranslationDto";
import ILanguageDto from "./LanguageDto.if";
import LanguageDto from "./LanguageDto";

function _site(this: IMediumDto, db: IModelSource): Promise<ISiteDto> {
    return DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto);
}

function _languages(this: IMediumDto, db: IModelSource): Promise<ILanguageDto[]> {
    const self = this;

    return new Promise(async function(resolve, reject) {
        try {
            /* this is ineffecient, but works. Fetch all translations, filter until the mediumId matches this & then fetch the related languages */
            const allSOTs = await DBUtil.allSiteObjectTranslations(db, SiteObjectTranslationDto);
            const matchSOTs = allSOTs.filter(sot => sot.mediumId === self.id);
            const languageIds = matchSOTs.map(sot => sot.languageId);
            const languages = await Promise.all(languageIds.map(id => DBUtil.loadLanguageId<ILanguageDto>(db, id, LanguageDto)));

            resolve(languages);
        } catch (error) {
            reject(`Error occured fetching MediumDto.languages: ${error}`);
        }
    })
};

export default (data: object) => { 
    const obj = Transformers.create<IMediumDto>(mappings, data);

    /* addLinkables */
    obj.site = _site;
    obj.languages = _languages;

    return obj;
}

